import { render } from "./SiteFooter.vue?vue&type=template&id=58a3fbae&scoped=true&bindings={\"shop\":\"data\",\"year\":\"options\"}"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=58a3fbae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58a3fbae"

export default script